var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("drawer", {
        ref: "filterDrawer",
        attrs: { filter_form: false },
        scopedSlots: _vm._u([
          {
            key: "tabs",
            fn: function () {
              return [
                _c(
                  "el-tabs",
                  {
                    staticClass: "bg-white",
                    on: {
                      "tab-click": function ($event) {
                        return _vm.toQuery()
                      },
                    },
                    model: {
                      value: _vm.listQuery.search_user_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "search_user_type", $$v)
                      },
                      expression: "listQuery.search_user_type",
                    },
                  },
                  [
                    _c("el-tab-pane", { attrs: { label: "我的", name: 0 } }),
                    _vm._v(" "),
                    _c("el-tab-pane", { attrs: { label: "下级", name: 1 } }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "p-5" }, [
        _c(
          "div",
          { staticClass: "bg-white" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                ref: "equip_table",
                attrs: {
                  id: "equip_table",
                  data: _vm.list,
                  "element-loading-text": "Loading",
                  stripe: "",
                  "highlight-current-row": "",
                  "max-height": _vm.tableMaxH,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "订单号", width: "115" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "dnone" }, [
                            _vm._v(
                              "【AGENT：" +
                                _vm._s(scope.row.agent_id) +
                                "】【APPID：" +
                                _vm._s(scope.row.appid) +
                                "】"
                            ),
                          ]),
                          _vm._v(
                            "\n          " +
                              _vm._s(scope.row.order_sn) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "交易单号", width: "142" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n          " +
                              _vm._s(scope.row.transaction_id) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "商户名称" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.store_name) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "下单时间" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.parseTime(
                                  scope.row.add_date,
                                  "{y}-{m}-{d} {h}:{i}:{s}"
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "设备名称" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.goods_name) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "设备编号" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.goods_sn) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "成本价(元)" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.cost_price) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "售价(元)" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.market_price) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "用户" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "flex align-center" },
                            [
                              _c("el-avatar", {
                                staticClass: "mr-5",
                                attrs: { size: 25, src: scope.row.user_avatar },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "flex1" }, [
                                _vm.config.system_other.order_amount_show ||
                                _vm.checkRoles(
                                  _vm.config.system_other.have_role
                                )
                                  ? _c("div", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(scope.row.user_mobile) +
                                          "\n                "
                                      ),
                                    ])
                                  : _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dealPhone(scope.row.user_mobile)
                                        )
                                      ),
                                    ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "text-cut" }, [
                                  _vm._v(
                                    _vm._s(scope.row.user_nick_name || "--")
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "操作",
                    width: "110",
                    fixed: _vm.device == "desktop" ? "right" : false,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              staticClass: "ml-10",
                              attrs: {
                                type: "primary",
                                size: "mini",
                                plain: "",
                                round: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getOrderDetail(scope.row)
                                },
                              },
                            },
                            [_vm._v("订单详情")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex justify-center" },
              [
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.listQuery.page_num > 0,
                      expression: "listQuery.page_num > 0",
                    },
                  ],
                  attrs: {
                    page: _vm.listQuery.start,
                    "page-count": _vm.listQuery.page_num,
                    limit: _vm.listQuery.limit,
                  },
                  on: {
                    "update:page": function ($event) {
                      return _vm.$set(_vm.listQuery, "start", $event)
                    },
                    "update:limit": function ($event) {
                      return _vm.$set(_vm.listQuery, "limit", $event)
                    },
                    pagination: _vm.getList,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "订单详情", visible: _vm.detailDialog },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialog = $event
            },
          },
        },
        [
          _vm.siteInfo.order_profits_detail_show == 1 ||
          _vm.checkRoles(_vm.config.system_other.have_role)
            ? [
                _c("div", { staticClass: "mt-10 mb-15 text-center" }, [
                  _vm._v("分成明细：" + _vm._s(_vm.order.profit_yuan)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex mb-10 text-center" }, [
                  _c("div", { staticClass: "flex1" }, [_vm._v("分成人")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex1" }, [_vm._v("分成比例")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex1" }, [_vm._v("分成金额")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex1" }, [_vm._v("退款金额")]),
                ]),
                _vm._v(" "),
                _vm._l(_vm.order.agents_profit, function (item) {
                  return [
                    item.agent_level >= _vm.agentInfo.agent_level
                      ? _c("div", { staticClass: "flex mb-10 text-center" }, [
                          _c("div", { staticClass: "flex1" }, [
                            _vm._v(
                              _vm._s(item.agent_name) +
                                "：" +
                                _vm._s(item.parent_name)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex1" }, [
                            _vm._v(_vm._s(item.profit_percent)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex1" }, [
                            _vm._v(_vm._s(item.get_profit) + "元"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex1" }, [
                            _vm._v(_vm._s(item.drawback_profit) + "元"),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }